module.exports = "/_next/static/images/logo-yatoo-vertical.vn-7a6cc20ff8704e257e0d7faf63de714b.png";